import { colors, fontSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const LoggedInAs = styled.div`
  border-top: 1px solid ${colors.borderLight};
  color: ${colors.textLight};
  font-size: ${fontSizes._14};
  margin-top: 1.5rem;
  padding-top: 1rem;
`

export const Email = styled.span`
  font-weight: 700;
`
